import React, { useEffect, useRef, useState } from "react";
import details from "./details.module.css";
import courseVideo from "./videos.module.css";
import {
  BlackDropUpIcon,
  BlueBegginerIcon,
  BlueDocumentIcon,
  BlueIconWatch,
  BlueQuizIcon,
  BlueStudentIcon,
  DocumentWhiteIcon,
  Dropdown,
} from "../../svg";
import { FaCheckCircle, FaRegCircle } from "react-icons/fa"; // Importing icons for play
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { AppBar, Box, CircularProgress, Tab, Tabs } from "@mui/material";
import FooterComponent from "../../component/FooterComponent";
import { getCourseImageUrl, formatCourseDuration } from "../helper/courseMedia";
import Quiz from "./Quiz";
import Assignment from "./Assignment";
import LiveSession from "./LiveSession";
import CommentSection from "./CommentSections";
import ReviwModal from "../../component/ReviewModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getActiveAssignment,
  getCertificate,
  getComment,
  getCourseDetails,
  getLiveSession,
  getProgressDetails,
  getQuiz,
  getUrl,
} from "../redux/courseSlice";
import api from "../helper/Api";
import formatDuration from "../helper/FormatDuration";
import "video.js/dist/video-js.css";
import VideoJS from "../../component/VideoJs";
import Toastify from "../helper/Toastify";
import { unwrapResult } from "@reduxjs/toolkit";

const CoursesVideos = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const courseId = useParams().id;

  const dispatch = useDispatch();
  const {
    courseDetailsData,
    urlData,
    quizData,
    progressDetailsData,
    liveSessionData,
    activeAssignmentData,
    getCommentData,
  } = useSelector((state) => state.courses);

  const user = useSelector((state) => state?.user?.data);
  const isLoading = useSelector((state) => state.courses.isLoading);
  const isRefresh = useSelector((state) => state.courses.isRefresh);

  const [isPlaying, setIsPlaying] = useState(false);
  const [expandedSection, setExpandedSection] = useState(null);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [data, setData] = useState(null);
  const [totalDuration, setTotalDuration] = useState(0);
  const [watchedCounts, setWatchedCounts] = useState({});

  const [selectedVideo, setSelectedVideo] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [liveTabValue, setLiveTabValue] = useState(0);
  const [reviewModal, setReviewModal] = useState(false);
  const moduleIdRef = useRef(null);
  const lectureIdRef = useRef(null);

  const [comments, setComments] = useState({
    currentPage: 1,
    loading: false,
    fetchingMore: false,
    totalComments: 0,
    data: [],
    totalItems: 0,
    totalPages: 0,
    limit: 2,
    skip: 0,
  });

  const [moduleId, setModuleId] = useState("");
  const [lectureId, setLectureId] = useState("");

  const isCourseCompleted = progressDetailsData?.totalProgress?.filter(
    (item) => item?.isCompleted === false
  );

  const playerRef = useRef(null);

  const modules = courseDetailsData?.course?.modules || [];
  const recordedModules = courseDetailsData?.course?.recordedModules || [];

  // Get the first upcoming live session
  const activeModules =
    modules.filter((module) => module.isSessionExpired === false) || [];
  const upcomingSession = activeModules.length > 0 ? activeModules[0] : null;

  //Effects

  useEffect(() => {
    // Scroll to 10% of the height of the page when the component mounts
    window.scrollTo(0, window.innerHeight * 0.1);
  }, []);

  useEffect(() => {
    dispatch(getCourseDetails(id));
    dispatch(getQuiz(id));
    dispatch(getLiveSession(id));
    dispatch(getActiveAssignment(id));
    dispatch(getCertificate(id));
  }, [dispatch, id, isRefresh]);

  useEffect(() => {
    const fetchComments = async () => {
      try {
        setComments((prev) => {
          return {
            ...prev,
            loading: true,
          };
        });

        const { data, status } = await api.getComment(
          `/student/get-comments/${id}?page=${comments.currentPage}`
        );

        if (status === 200) {
          setComments((prev) => {
            const cloneData = prev.data;
            return {
              ...prev,
              loading: false,
              totalComments: data.totalComments,
              data: data.populatedComments,
              totalItems: data.totalItems,
              totalPages: data.totalPages,
              limit: 10,
            };
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setComments((prev) => {
          return {
            ...prev,
            fetchingMore: false,
            loading: false,
          };
        });
      }
    };

    if (!comments.loading) {
      fetchComments();
    }
  }, [id]);

  const fetchComments = async (page) => {
    try {
      setComments((prev) => {
        return {
          ...prev,
          loading: false,
          fetchingMore: true,
        };
      });

      const { data, status } = await api.getComment(
        `/student/get-comments/${id}?page=${page}&skip=${comments.skip}`
      );

      if (status === 200) {
        setComments((prev) => {
          const cloneData = prev.data;
          return {
            ...prev,
            currentPage: page,
            data: [...cloneData, ...data.populatedComments],
            totalItems: data.totalItems,
            totalPages: data.totalPages,
            limit: 10,
          };
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setComments((prev) => {
        return {
          ...prev,
          fetchingMore: false,
          loading: false,
        };
      });
    }
  };

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const res = await dispatch(getProgressDetails(id));
        const data = await unwrapResult(res);

        let watched = {};
        data?.totalProgress?.forEach((lecture) => {
          watched[lecture.lectureId] = lecture.isCompleted;
        });

        setWatchedCounts(watched);

        const modulesList = courseDetailsData?.course?.modules;

        if (data?.currentPlayingLecture?.parentId) {
          const parentId = data?.currentPlayingLecture?.parentId;
          const lectureIdProgress = data?.currentPlayingLecture?.lectureId;

          const ModuleIndex = modulesList?.findIndex(
            (module) => module._id === parentId
          );
          if (ModuleIndex < 0 || !modulesList?.length) {
            return;
          }
          const module = modulesList[ModuleIndex];
          const LectureIndex = module?.lectures?.findIndex(
            (lecture) => lecture._id === lectureIdProgress
          );
          if (LectureIndex < 0) {
            return;
          }
          const lecture = module?.lectures?.[LectureIndex];
          const video = lecture?.video;

          toggleSection(ModuleIndex, module?._id);
          await selectLesson(
            LectureIndex,
            video,
            lecture?._id,
            lecture?.totalLectureDuration
          );
        } else {
          const firstModule = modulesList?.[0];
          const firstLecture = firstModule?.lectures?.[0];
          if (!firstModule || !firstLecture) {
            return;
          }
          const video = firstLecture?.video;

          toggleSection(0, firstModule._id);
          await selectLesson(
            0,
            video,
            firstLecture._id,
            firstLecture?.totalLectureDuration
          );
        }
      } catch (e) {
        console.error("fetchProgress failed", e);
      }
    };

    if (
      courseDetailsData?.course?._id &&
      courseDetailsData?.course?.courseType !== "LIVESTREAM"
    ) {
      fetchProgress();
    }
  }, [id, courseDetailsData?.course?._id]);

  useEffect(() => {
    dispatch(getUrl({ key: selectedVideo }));
  }, [selectedVideo]);

  const updateVideoDuration = async (playedSeconds) => {
    try {
      const data = {
        courseId: id,
        parentId: moduleId,
        lectureId: lectureId,
        watchedDuration: playedSeconds,
        totalDuration: totalDuration,
      };
      const { status } = await api.updateVideoCount(data);
    } catch (error) {
      console.error("Error fetching course count", error);
    }
  };

  const openReviewModal = (id) => {
    setData(id);
    setReviewModal(true);
  };

  const closeReviewModal = () => {
    setReviewModal(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const toggleSection = (index, id) => {
    setModuleId(id);
    moduleIdRef.current = id;
    setExpandedSection(expandedSection === index ? null : index);
  };

  const selectLesson = async (lessonIndex, videoArray, id, duration) => {
    const urlData = videoArray?.length > 0 ? videoArray[0] : "";
    setSelectedLesson(lessonIndex);
    setSelectedVideo(urlData); // Update the selected video URL
    setLectureId(id);
    setIsPlaying(true);
    setTotalDuration(duration);

    try {
      const { data, status } = await api.addCurrentVideo({
        courseId,
        parentId: moduleIdRef.current,
        lectureId: id,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const totalStars = 5;

  // Function to generate star rating dynamically
  const renderStars = () => {
    const filledStars = Math.floor(courseDetailsData?.overallRating) || 0; // Number of filled stars
    const halfStars = courseDetailsData?.overallRating % 1 >= 0.5 ? 1 : 0; // Determine if there's a half star
    const emptyStars = totalStars - filledStars - halfStars; // Remaining stars to be empty

    return (
      <>
        {[...Array(filledStars)]?.map((_, i) => (
          <AiFillStar key={i} className={courseVideo.starIcon} />
        ))}
        {[...Array(emptyStars)]?.map((_, i) => (
          <AiOutlineStar
            key={filledStars + i}
            className={courseVideo.starIcon}
          />
        ))}
      </>
    );
  };

  const formatLivesessionDateTime = (date, startTime, endTime) => {
    // Format the date
    const formattedDate = new Date(date).toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });

    // Format the start time
    const formattedStartTime = new Date(
      `${date.split("T")[0]}T${startTime}`
    ).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true, // Ensures AM/PM
    });

    // Format the end time
    const formattedEndTime = new Date(
      `${date.split("T")[0]}T${endTime}`
    ).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true, // Ensures AM/PM
    });

    return `${formattedDate} @ ${formattedStartTime} - ${formattedEndTime}`;
  };
  const formatDate = (date) => {
    const dateFromMongoDB = new Date(date);
    const formattedDate = dateFromMongoDB.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short", // This will give abbreviated month names (e.g., Dec)
      year: "numeric",
    });
    return formattedDate;
  };

  const videoJsOptions = {
    controls: true,
    responsive: true,
    fluid: true,
    // playbackRates: [0.5, 1, 1.5, 2], // Define playback speeds
    autoplay: false, // autoplay the videos
    muted: true,
    // poster: 'https://ik.imagekit.io/ikmedia/example_video.mp4/ik-thumbnail.jpg?tr=w-1200,h-680',
    sources: [
      {
        src: `${urlData}`,
        type: "video/mp4",
      },
    ],
    tracks: [
      {
        kind: "subtitles",
        src: "your-subtitles-file.vtt",
        label: "English",
        srclang: "en",
      },
    ],
    playbackRateMenuButton: true,
    aspectRatio: "16:9",
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    // Additional events for debugging
    player.on("timeupdate", () => {
      console.log("Current playback time:", player.currentTime());
      // updateVideoDuration(player.currentTime())
    });

    player.on("loadeddata", () => {
      // Set the video to start from 1 second
      player.currentTime(1);
    });

    player.on("pause", () => {
      console.log("Video paused at:", player.currentTime());
    });

    player.on("play", () => {
      console.log("Video resumed at:", player.currentTime());
    });

    player.on("ended", async () => {
      setTimeout(() => {
        setWatchedCounts((prev) => ({
          ...prev,
          [lectureId]: true, // Mark as watched if 90% completed
        }));
      }, 200);

      let ModuleIndex = courseDetailsData?.course?.modules.findIndex(
        (module) => module._id === moduleId
      );
      let module = courseDetailsData?.course?.modules[ModuleIndex];
      let LectureIndex = module?.lectures?.findIndex(
        (lecture) => lecture._id === lectureId
      );

      // Check if this is a LIVESTREAM course and we're viewing recorded modules
      if (
        courseDetailsData?.course?.courseType === "LIVESTREAM" &&
        liveTabValue === 1
      ) {
        // Use recordedModules instead of modules
        ModuleIndex = recordedModules.findIndex(
          (module) => module._id === moduleId
        );
        module = recordedModules[ModuleIndex];
        LectureIndex = module?.lectures?.findIndex(
          (lecture) => lecture._id === lectureId
        );
      }

      // Store the current module index to check if we're switching modules
      const previousModuleIndex = ModuleIndex;

      if (LectureIndex < module?.lectures?.length - 1) {
        // If there are more lectures in the current module, go to the next lecture
        LectureIndex = LectureIndex + 1;
      } else if (
        ModuleIndex <
        (courseDetailsData?.course?.courseType === "LIVESTREAM" &&
        liveTabValue === 1
          ? recordedModules.length
          : courseDetailsData?.course?.modules.length) -
          1
      ) {
        // If we've reached the end of lectures in the current module but there are more modules, go to the first lecture of the next module
        ModuleIndex = ModuleIndex + 1;
        module =
          courseDetailsData?.course?.courseType === "LIVESTREAM" &&
          liveTabValue === 1
            ? recordedModules[ModuleIndex]
            : courseDetailsData?.course?.modules[ModuleIndex];
        LectureIndex = 0;
      } else {
        // If we've reached the end of all modules and lectures, do nothing or maybe show a completion message
        console.log("Course completed!");
        return;
      }

      let lecture = module?.lectures?.[LectureIndex];
      if (!lecture) {
        console.log("No more lectures available");
        return;
      }

      let video = lecture?.video;

      // Only toggle the section if we're moving to a different module
      if (previousModuleIndex !== ModuleIndex) {
        toggleSection(ModuleIndex, module?._id);
      }

      await selectLesson(
        LectureIndex,
        video,
        lecture?._id,
        lecture?.totalLectureDuration
      );
    });
  };

  const hasActiveModules =
    Array.isArray(activeModules) && activeModules.length > 0;

  return (
    <div>
      <div className={details.mainContainer}>
        <div className={details.childContent}>
          <div
            className={courseVideo.courseVideo}
            onClick={() => navigate("/studentDashboard/StudentDashboard")}
          >
            Back to list
          </div>
          {/* {isCourseCompleted?.length === 0 && ( */}
          <div
            className={courseVideo.courseVideo}
            style={{ color: "#1179EF" }}
            onClick={() => openReviewModal(id)}
          >
            Write A Review
          </div>
          {/* )} */}
        </div>
        {/* <h1> AAAAAAAAAAAAAA{courseDetailsData?.course?.courseType}</h1> */}
        <div className={courseVideo.childContent} style={{ marginTop: 20 }}>
          <div className={courseVideo.videoPlayer}>
            <div className={courseVideo.videoContainer}>
              <div className={courseVideo.videoPlayerWrapper}>
                {urlData ? (
                  <div>
                    <VideoJS
                      options={videoJsOptions}
                      onReady={handlePlayerReady}
                      updateVideoDuration={updateVideoDuration}
                      urlData={urlData}
                      showRecordedText={
                        courseDetailsData?.course?.courseType !== "RECORDED" &&
                        liveTabValue === 0
                      }
                    />
                  </div>
                ) : (
                  <div className={courseVideo.videoThumbnail}>
                    <img
                      src={getCourseImageUrl(courseDetailsData?.course?.thumbnail)}
                      alt="Video Thumbnail"
                      className={courseVideo.thumbnailImage}
                    />
                    <button
                      className={courseVideo.playButton}
                      onClick={() => setIsPlaying(true)}
                    >
                      &#9658; {/* Play button icon */}
                    </button>
                  
                  </div>
                )}
              </div>
            </div>
            <div className={courseVideo.courseCard}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p className={courseVideo.lastUpdated}>
                  Last Updated:{" "}
                  <span>
                    {formatDate(courseDetailsData?.course?.updatedAt)}
                  </span>{" "}
                </p>

                {courseDetailsData?.course?.courseType === "LIVESTREAM" ? (
                  <div
                    style={{
                      color: "rgba(29, 131, 248, 1)",
                      background: "rgba(29, 131, 248, 0.1)",
                      padding: "5px 15px",
                      fontWeight: "600",
                      fontSize: "12px",
                      borderRadius: "16px",
                    }}
                  >
                    {" "}
                    • Live
                  </div>
                ) : (
                  <div
                    style={{
                      color: "rgba(29, 131, 248, 1)",
                      background: "rgba(29, 131, 248, 0.1)",
                      padding: "5px 15px",
                      fontWeight: "600",
                      fontSize: "12px",
                      borderRadius: "16px",
                    }}
                  >
                    {" "}
                    • Recorded
                  </div>
                )}
              </div>
              <h2 className={courseVideo.courseTitle}>
                {courseDetailsData?.course?.title}
              </h2>
              <p className={courseVideo.courseDescription}>
                {courseDetailsData?.course?.subtitle}
              </p>
              <div className={courseVideo.courseRatingMobileView}>
                {renderStars()}
                <span className={courseVideo.ratingScore}>
                  {courseDetailsData?.overallRating}
                </span>
                <span className={courseVideo.ratingCount}>
                  ({courseDetailsData?.totalRating} Rating)
                </span>
              </div>
              <div className={courseVideo.courseAuthor}>
                {/* <div style={{ display: 'flex' }}>
                                    <img src={courseDetailsData?.course?.createdBy[0]?.profileImg} alt="John Smith" className={courseVideo.authorImage} />
                                    <div >
                                        <div className={courseVideo.courseCreator}>Created by:</div>
                                        <div className={courseVideo.authorDetails}>
                                            <p className={courseVideo.authorName}>{courseDetailsData?.course?.createdBy[0]?.name}</p>
                                            <div className={courseVideo.roundStyle} />
                                            <p className={courseVideo.authorRole}>{courseDetailsData?.course?.createdBy[0]?.name}</p>
                                        </div>
                                    </div>
                                </div> */}
                <div className={courseVideo.courseRating}>
                  {renderStars()}
                  <span className={courseVideo.ratingScore}>
                    {courseDetailsData?.overallRating}
                  </span>
                  <span className={courseVideo.ratingCount}>
                    ({courseDetailsData?.totalRating} Rating)
                  </span>
                </div>
              </div>

              <div className={courseVideo.courseDetails}>
                <span className={courseVideo.iconsStyle}>
                  <BlueIconWatch /> {formatCourseDuration(courseDetailsData?.course?.duration)}
                </span>
                <span className={courseVideo.iconsStyle}>
                  <BlueStudentIcon /> {courseDetailsData?.totalStudents}{" "}
                  Students
                </span>
                <span className={courseVideo.iconsStyle}>
                  <BlueBegginerIcon /> {courseDetailsData?.course?.courseLevel}
                </span>
                <span className={courseVideo.iconsStyle}>
                  <BlueDocumentIcon />{" "}
                  {courseDetailsData?.course?.modules.length} Lessons
                </span>
                <span className={courseVideo.iconsStyle}>
                  <BlueQuizIcon /> 1 Quizzes
                </span>
              </div>
            </div>
            <div className={courseVideo.tabsStyle}>
              <Box>
                <AppBar position="static" color="transparent" elevation={0}>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    sx={{
                      width: "100%",
                      "& .MuiTab-root": {
                        textTransform: "capitalize",
                        fontFamily: "Figtree",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "14px",
                          lg: "16px",
                        },
                        fontWeight: "500",
                        lineHeight: "22px",
                        textAlign: "left",
                        color: "#6E7485",
                        paddingLeft: {
                          xs: "2px",
                          sm: "2px",
                          md: "2px",
                          lg: "5px",
                        },
                        borderBottom: "1px solid #E9EAF0",
                        "&.Mui-selected": {
                          color: "#1D83F8", // Color when tab is selected
                          fontWeight: "600", // Increase boldness when selected
                          "&.MuiTab-iconWrapper": {
                            color: "#1D83F8", // Change icon color when selected
                          },
                        },
                      },
                      "& .MuiTabs-indicator": {
                        backgroundColor: "#3D70F5", // Indicator color
                        height: "2px", // Thickness of the indicator
                      },
                    }}
                  >
                    <Tab label="General" />
                    <Tab label="Quiz" />
                    <Tab label="Assignment" />
                    <Tab label="Doubt Session" />
                    <Tab label="Discussion Forum" />
                  </Tabs>
                </AppBar>
                {tabValue === 0 ? (
                  <>
                    <div
                      className={courseVideo.courseCertification}
                      style={{ marginTop: 20 }}
                    >
                      <div className={courseVideo.authorName}>
                        Certification
                      </div>
                      <div className={courseVideo.descriptionText}>
                        Get Course certification by completing entire course
                      </div>
                      {isCourseCompleted?.length === 0 ? (
                        <div
                          className={courseVideo.activeCertificateStyle}
                          // onClick={() =>
                          //   navigate(
                          //     `/courses/Courses/CourseDetails/CoursesVideos/CourseCompletion/${id}`
                          //   )
                          // }
                          onClick={async () => {
                            try {
                              // API call to create a document in the database
                              // const response = await fetch('/api/createDocument', {
                              //   method: 'POST',
                              //   headers: {
                              //     'Content-Type': 'application/json',
                              //   },
                              //   body: JSON.stringify({ id }), // Pass necessary data here
                              // });

                              const { data, status } =
                                await api.createCertifiacte({
                                  studentId: `${user?._id}`,
                                  courseId: `${id}`,
                                  adminSignature: [
                                    "https://kingster-dev-public.s3.ap-south-1.amazonaws.com/undefined/7817353944849605475.jpg",
                                  ],
                                });

                              if (status === 200) {
                                // Navigate only if the document creation is successful
                                navigate(
                                  `/courses/Courses/CourseDetails/CoursesVideos/CourseCompletion/${id}/${user?._id}`
                                );
                              } else {
                                // console.error('Failed to create the document:', await response.json());
                                alert(
                                  "Unable to complete the action. Please try again."
                                );
                              }
                            } catch (error) {
                              // alert(error?.response?.data?.message);
                              Toastify.error(error?.response?.data?.message);
                            }
                          }}
                        >
                          {/* <img src='/event_note.png' /> */}
                          <DocumentWhiteIcon />
                          <span>Kingster Certificate</span>
                        </div>
                      ) : (
                        <div
                          //  className={courseVideo.certificateStyle}
                          className={
                            courseDetailsData?.course?.courseType ===
                            "LIVESTREAM"
                              ? courseVideo.activeCertificateStyle
                              : courseVideo.certificateStyle
                          }
                          onClick={() => {
                            if (
                              courseDetailsData?.course?.courseType ===
                              "LIVESTREAM"
                            ) {
                              navigate(
                                `/courses/Courses/CourseDetails/CoursesVideos/CourseCompletion/${id}/${user?._id}`
                              );
                            }
                          }}
                        >
                          <img src="/event_note.png" />
                          <span>Kingster Certificate</span>
                        </div>
                      )}
                    </div>
                    <div
                      className={courseVideo.courseCertification}
                      style={{ marginTop: 20 }}
                    >
                      <div className={courseVideo.authorName}>Description</div>
                      <div className={courseVideo.descriptionText}>
                        <p>
                          It gives you a huge self-satisfaction when you look at
                          your work and say, "I made this!". I love that feeling
                          after I'm done working on something. When I lean back
                          in my chair, look at the final result with a smile,
                          and have this little "spark joy" moment. It's
                          especially satisfying when I know I just made $5,000.
                        </p>
                        <p>
                          I do! And that's why I got into this field. Not for
                          the love of Web Design, which I do now. But for the
                          LIFESTYLE! There are many ways one can achieve this
                          lifestyle. This is my way. This is how I achieved a
                          lifestyle I've been fantasizing about for five years.
                          And I'm going to teach you the same. Often people
                          think Web Design is complicated. That it needs some
                          creative talent or knack for computers. Sure, a lot of
                          people make it very complicated. People make the
                          simplest things complicated. Like most subjects taught
                          in the universities. But I don't like complicated. I
                          like easy. I like life hacks. I like to take the
                          shortest and simplest route to my destination. I
                          haven't gone to an art school or have a computer
                          science degree. I'm an outsider to this field who
                          hacked himself into it, somehow ending up being a
                          sought-after professional. That's how I'm going to
                          teach you Web Design. So you're not demotivated on
                          your way with needless complexity. So you enjoy the
                          process because it's simple and fun. So you can become
                          a Freelance Web Designer in no time.
                        </p>
                        <p>
                          For example, this is a Design course but I don't teach
                          you Photoshop. Because Photoshop is needlessly
                          complicated for Web Design. But people still teach it
                          to web designers. I don't. I teach Figma – a simple
                          tool that is taking over the design world. You will be
                          designing a complete website within a week while
                          others are still learning how to create basic layouts
                          in Photoshop.
                        </p>
                        <p>
                          Second, this is a Development course. But I don't
                          teach you how to code. Because for Web Design coding
                          is needlessly complicated and takes too long to learn.
                          Instead, I teach Webflow – a tool that is taking over
                          the web design world. You will be building complex
                          websites within two weeks while others are still
                          learning the basics of HTML & CSS. Third, this is a
                          Freelancing course. But I don't just teach you how to
                          write great proposals. I give you a winning proposal
                          template. When you're done with the course, you will
                          have a stunning portfolio website with portfolio
                          pieces already in it. Buy this course now and take it
                          whenever the time is right for you.
                        </p>
                      </div>
                    </div>
                  </>
                ) : tabValue === 1 ? (
                  <>
                    <Quiz
                      isCompleted={isCourseCompleted}
                      courseType={courseDetailsData?.course?.courseType}
                      initialQuizData={quizData}
                      isLoading={isLoading}
                      courseId={id}
                    />
                  </>
                ) : tabValue === 2 ? (
                  <>
                    <Assignment
                      isCompleted={isCourseCompleted}
                      courseType={courseDetailsData?.course?.courseType}
                      activeAssignmentData={activeAssignmentData}
                      isLoading={isLoading}
                      courseId={id}
                    />
                  </>
                ) : tabValue === 3 ? (
                  <>
                    <LiveSession
                      liveSessionData={liveSessionData}
                      isLoading={isLoading}
                    />
                  </>
                ) : tabValue === 4 ? (
                  <>
                    {isLoading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    ) : (
                      <CommentSection
                        data={comments}
                        id={id}
                        setData={setComments}
                        fetchData={fetchComments}
                      />
                    )}
                  </>
                ) : null}
              </Box>
            </div>
            <div className={courseVideo.tabsMobileViewStyle}>
              <Box>
                <AppBar position="static" color="transparent" elevation={0}>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="scrollable" // Enables horizontal scrolling for tabs
                    scrollButtons="auto" // Automatically shows scroll buttons when needed
                    sx={{
                      width: "100%",
                      "& .MuiTab-root": {
                        textTransform: "capitalize",
                        fontFamily: "Figtree",
                        fontSize: { xs: "12px", sm: "14px", md: "16px" },
                        fontWeight: "500",
                        lineHeight: "22px",
                        textAlign: "left",
                        color: "#6E7485",
                        paddingLeft: {
                          xs: "2px",
                          sm: "2px",
                          md: "2px",
                          lg: "5px",
                        },
                        borderBottom: "1px solid #E9EAF0",
                        "&.Mui-selected": {
                          color: "#1D83F8", // Color when tab is selected
                          fontWeight: "600", // Increase boldness when selected
                          "&.MuiTab-iconWrapper": {
                            color: "#1D83F8", // Change icon color when selected
                          },
                        },
                      },
                      "& .MuiTabs-indicator": {
                        backgroundColor: "#3D70F5", // Indicator color
                        height: "2px", // Thickness of the indicator
                      },
                    }}
                  >
                    <Tab label="Content" />
                    <Tab label="General" />
                    <Tab label="Quiz" />
                    <Tab label="Assignment" />
                    <Tab label="Live session" />
                    <Tab label="Discussion Forum" />
                  </Tabs>
                </AppBar>
                {tabValue === 0 ? (
                  <div className={courseVideo.videoSessionMobileBox}>
                    <div className={courseVideo.courseContent}>
                      {courseDetailsData?.course?.courseType ===
                      "LIVESTREAM" ? (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px 20px",
                              borderBottom: "1px solid #E9EAF0",
                            }}
                          >
                            <div
                              onClick={() => setLiveTabValue(0)}
                              style={{
                                cursor: "pointer",
                                padding: "10px 15px",
                                fontWeight: liveTabValue === 0 ? "600" : "400",
                                color:
                                  liveTabValue === 0 ? "#1D83F8" : "#6E7485",
                                borderBottom:
                                  liveTabValue === 0
                                    ? "2px solid #1D83F8"
                                    : "none",
                              }}
                            >
                              Live Sessions
                            </div>
                            <div
                              onClick={() => setLiveTabValue(1)}
                              style={{
                                cursor: "pointer",
                                padding: "10px 15px",
                                fontWeight: liveTabValue === 1 ? "600" : "400",
                                color:
                                  liveTabValue === 1 ? "#1D83F8" : "#6E7485",
                                borderBottom:
                                  liveTabValue === 1
                                    ? "2px solid #1D83F8"
                                    : "none",
                              }}
                            >
                              Recorded Videos
                            </div>
                          </div>

                          {liveTabValue === 0 ? (
                            <div
                              style={{
                                display: "flex",
                                background: "rgba(248, 93, 93, 0.05)",
                                padding: "20px",
                              }}
                            >
                              <div style={{ width: "80%" }}>
                                <div
                                  style={{
                                    color: "rgba(249, 51, 51, 1)",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Live session
                                </div>

                                {upcomingSession ? (
                                  <div
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {formatLivesessionDateTime(
                                      upcomingSession.liveSessionDate,
                                      upcomingSession.liveSessionStartTime,
                                      upcomingSession.liveSessionEndTime
                                    )}
                                  </div>
                                ) : (
                                  <span>No live sessions available</span>
                                )}
                              </div>

                              {upcomingSession && (
                                <button
                                  onClick={() => {
                                    if (upcomingSession?.meetingURL) {
                                      navigate(
                                        `/courses/join/${upcomingSession.meetingId}?meetingPassword=${upcomingSession.meetingPassword}&callbackURL=${location.pathname}`
                                      );
                                    }
                                  }}
                                  style={{
                                    color: "#fff",
                                    background: "rgba(29, 131, 248, 1)",
                                    borderRadius: "25px",
                                    padding: "15px 19px",
                                  }}
                                >
                                  Join
                                </button>
                              )}
                            </div>
                          ) : (
                            <div style={{ padding: "20px" }}>
                              Recorded Videos
                            </div>
                          )}
                        </>
                      ) : (
                        <div style={{ padding: "20px" }}>Course content</div>
                      )}
                    </div>

                    {/* Only show modules if we're on the Recorded Videos tab for live courses, or for regular courses */}
                    {courseDetailsData?.course?.courseType !== "LIVESTREAM"
                      ? // Regular courses - show modules
                        courseDetailsData?.course?.modules?.map(
                          (section, index) => {
                            const watchedLectures = section?.lectures?.filter(
                              (lecture) => watchedCounts[lecture._id]
                            ).length;
                            const totalLectures = section?.lectures?.length;
                            return (
                              <div
                                key={index}
                                className={courseVideo.courseSection}
                              >
                                <div
                                  className={
                                    expandedSection === index &&
                                    moduleId === section?._id
                                      ? `${courseVideo.selectedLessonStyle}`
                                      : `${courseVideo.courseSectionHeader}`
                                  }
                                  onClick={() =>
                                    toggleSection(index, section?._id)
                                  }
                                >
                                  <div>
                                    <div>
                                      {" "}
                                      {index < 9 && 0}
                                      {index + 1} - {section.title}
                                    </div>
                                    <span
                                      className={courseVideo.lessonDuration}
                                    >
                                      {watchedLectures}/{totalLectures}
                                    </span>
                                    <span
                                      className={courseVideo.lessonDuration}
                                    >
                                      (
                                      {formatDuration(
                                        section.totalModuleDuration
                                      )}
                                      )
                                    </span>
                                  </div>
                                  <div>
                                    {expandedSection === index &&
                                    moduleId === section?._id ? (
                                      <BlackDropUpIcon />
                                    ) : (
                                      <Dropdown />
                                    )}
                                  </div>
                                </div>
                                {expandedSection === index &&
                                  section?.lectures?.length > 0 && (
                                    <div className={courseVideo.lessonList}>
                                      {section?.lectures?.map(
                                        (lesson, lessonIndex) => (
                                          <div
                                            key={lessonIndex}
                                            className={
                                              selectedLesson === lessonIndex
                                                ? courseVideo.selectedLesson
                                                : courseVideo.lessonItem
                                            }
                                            onClick={async () =>
                                              await selectLesson(
                                                lessonIndex,
                                                lesson.video, // Pass the video URL
                                                lesson._id,
                                                lesson.totalLectureDuration
                                              )
                                            }
                                          >
                                            <div
                                              className={
                                                courseVideo.selectedSubVideo
                                              }
                                            >
                                              <div>
                                                {selectedLesson ===
                                                  lessonIndex ||
                                                watchedCounts[lesson._id] ? (
                                                  <FaCheckCircle
                                                    className={
                                                      courseVideo.playIcon
                                                    }
                                                  />
                                                ) : (
                                                  <FaRegCircle
                                                    className={
                                                      courseVideo.circleIcon
                                                    }
                                                  />
                                                )}
                                              </div>
                                              <div>
                                                <div
                                                  className={
                                                    courseVideo.headinStyle
                                                  }
                                                >
                                                  <img src="/videoIcon.png" />
                                                  {lessonIndex < 9 && 0}
                                                  {lessonIndex + 1} -{" "}
                                                  {lesson.title}
                                                </div>
                                                <span
                                                  className={
                                                    courseVideo.lessonDuration
                                                  }
                                                >
                                                  (
                                                  {formatDuration(
                                                    lesson?.totalLectureDuration
                                                  )}
                                                  )
                                                </span>
                                              </div>
                                            </div>
                                            {selectedLesson === lessonIndex &&
                                              lesson?.attachFiles?.url?.length >
                                                0 && (
                                                <div
                                                  className={
                                                    courseVideo.lessonOptions
                                                  }
                                                  onClick={() => {
                                                    window.open(
                                                      lesson?.attachFiles
                                                        ?.url?.[0],
                                                      "_blank"
                                                    );
                                                  }}
                                                >
                                                  <img src="/event_note.png" />
                                                  <span>Resources</span>
                                                </div>
                                              )}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                              </div>
                            );
                          }
                        )
                      : // LIVESTREAM courses - show modules or recordedModules based on tab
                      liveTabValue === 0
                      ? // Live Sessions tab - show modules
                        courseDetailsData?.course?.modules?.map(
                          (section, index) => {
                            const watchedLectures = section?.lectures?.filter(
                              (lecture) => watchedCounts[lecture._id]
                            ).length;
                            const totalLectures = section?.lectures?.length;
                            return (
                              <div
                                key={index}
                                className={courseVideo.courseSection}
                              >
                                <div
                                  className={
                                    expandedSection === index &&
                                    moduleId === section?._id
                                      ? `${courseVideo.selectedLessonStyle}`
                                      : `${courseVideo.courseSectionHeader}`
                                  }
                                  onClick={() =>
                                    toggleSection(index, section?._id)
                                  }
                                >
                                  <div>
                                    <div>
                                      {" "}
                                      {index < 9 && 0}
                                      {index + 1} - {section.title}
                                    </div>
                                    <span
                                      className={courseVideo.lessonDuration}
                                    >
                                      {watchedLectures}/{totalLectures}
                                    </span>
                                    <span
                                      className={courseVideo.lessonDuration}
                                    >
                                      (
                                      {formatDuration(
                                        section.totalModuleDuration
                                      )}
                                      )
                                    </span>
                                  </div>
                                  <div>
                                    {expandedSection === index &&
                                    moduleId === section?._id ? (
                                      <BlackDropUpIcon />
                                    ) : (
                                      <Dropdown />
                                    )}
                                  </div>
                                </div>
                                {expandedSection === index &&
                                  section?.lectures?.length > 0 && (
                                    <div className={courseVideo.lessonList}>
                                      {section?.lectures?.map(
                                        (lesson, lessonIndex) => (
                                          <div
                                            key={lessonIndex}
                                            className={
                                              selectedLesson === lessonIndex
                                                ? courseVideo.selectedLesson
                                                : courseVideo.lessonItem
                                            }
                                            onClick={async () =>
                                              await selectLesson(
                                                lessonIndex,
                                                lesson.video, // Pass the video URL
                                                lesson._id,
                                                lesson.totalLectureDuration
                                              )
                                            }
                                          >
                                            <div
                                              className={
                                                courseVideo.selectedSubVideo
                                              }
                                            >
                                              <div>
                                                {selectedLesson ===
                                                  lessonIndex ||
                                                watchedCounts[lesson._id] ? (
                                                  <FaCheckCircle
                                                    className={
                                                      courseVideo.playIcon
                                                    }
                                                  />
                                                ) : (
                                                  <FaRegCircle
                                                    className={
                                                      courseVideo.circleIcon
                                                    }
                                                  />
                                                )}
                                              </div>
                                              <div>
                                                <div
                                                  className={
                                                    courseVideo.headinStyle
                                                  }
                                                >
                                                  <img src="/videoIcon.png" />
                                                  {lessonIndex < 9 && 0}
                                                  {lessonIndex + 1} -{" "}
                                                  {lesson.title}
                                                </div>
                                                <span
                                                  className={
                                                    courseVideo.lessonDuration
                                                  }
                                                >
                                                  (
                                                  {formatDuration(
                                                    lesson?.totalLectureDuration
                                                  )}
                                                  )
                                                </span>
                                              </div>
                                            </div>
                                            {selectedLesson === lessonIndex &&
                                              lesson?.attachFiles?.url?.length >
                                                0 && (
                                                <div
                                                  className={
                                                    courseVideo.lessonOptions
                                                  }
                                                  onClick={() => {
                                                    window.open(
                                                      lesson?.attachFiles
                                                        ?.url?.[0],
                                                      "_blank"
                                                    );
                                                  }}
                                                >
                                                  <img src="/event_note.png" />
                                                  <span>Resources</span>
                                                </div>
                                              )}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                              </div>
                            );
                          }
                        )
                      : // Recorded Videos tab - show recordedModules
                        recordedModules?.map((section, index) => {
                          const watchedLectures = section?.lectures?.filter(
                            (lecture) => watchedCounts[lecture._id]
                          ).length;
                          const totalLectures = section?.lectures?.length;
                          return (
                            <div
                              key={index}
                              className={courseVideo.courseSection}
                            >
                              <div
                                className={
                                  expandedSection === index &&
                                  moduleId === section?._id
                                    ? `${courseVideo.selectedLessonStyle}`
                                    : `${courseVideo.courseSectionHeader}`
                                }
                                onClick={() =>
                                  toggleSection(index, section?._id)
                                }
                              >
                                <div>
                                  <div>
                                    {" "}
                                    {index < 9 && 0}
                                    {index + 1} - {section.title}
                                  </div>
                                  <span className={courseVideo.lessonDuration}>
                                    {watchedLectures}/{totalLectures}
                                  </span>
                                  <span className={courseVideo.lessonDuration}>
                                    (
                                    {formatDuration(
                                      section.totalModuleDuration
                                    )}
                                    )
                                  </span>
                                </div>
                                <div>
                                  {expandedSection === index &&
                                  moduleId === section?._id ? (
                                    <BlackDropUpIcon />
                                  ) : (
                                    <Dropdown />
                                  )}
                                </div>
                              </div>
                              {expandedSection === index &&
                                section?.lectures?.length > 0 && (
                                  <div className={courseVideo.lessonList}>
                                    {section?.lectures?.map(
                                      (lesson, lessonIndex) => (
                                        <div
                                          key={lessonIndex}
                                          className={
                                            selectedLesson === lessonIndex
                                              ? courseVideo.selectedLesson
                                              : courseVideo.lessonItem
                                          }
                                          onClick={async () =>
                                            await selectLesson(
                                              lessonIndex,
                                              lesson.video, // Pass the video URL
                                              lesson._id,
                                              lesson.totalLectureDuration
                                            )
                                          }
                                        >
                                          <div
                                            className={
                                              courseVideo.selectedSubVideo
                                            }
                                          >
                                            <div>
                                              {selectedLesson === lessonIndex ||
                                              watchedCounts[lesson._id] ? (
                                                <FaCheckCircle
                                                  className={
                                                    courseVideo.playIcon
                                                  }
                                                />
                                              ) : (
                                                <FaRegCircle
                                                  className={
                                                    courseVideo.circleIcon
                                                  }
                                                />
                                              )}
                                            </div>
                                            <div>
                                              <div
                                                className={
                                                  courseVideo.headinStyle
                                                }
                                              >
                                                <img src="/videoIcon.png" />
                                                {lessonIndex < 9 && 0}
                                                {lessonIndex + 1} -{" "}
                                                {lesson.title}
                                              </div>
                                              <span
                                                className={
                                                  courseVideo.lessonDuration
                                                }
                                              >
                                                (
                                                {formatDuration(
                                                  lesson?.totalLectureDuration
                                                )}
                                                )
                                              </span>
                                            </div>
                                          </div>
                                          {selectedLesson === lessonIndex &&
                                            lesson?.attachFiles?.url?.length >
                                              0 && (
                                              <div
                                                className={
                                                  courseVideo.lessonOptions
                                                }
                                                onClick={() => {
                                                  window.open(
                                                    lesson?.attachFiles
                                                      ?.url?.[0],
                                                    "_blank"
                                                  );
                                                }}
                                              >
                                                <img src="/event_note.png" />
                                                <span>Resources</span>
                                              </div>
                                            )}
                                        </div>
                                      )
                                    )}
                                  </div>
                                )}
                            </div>
                          );
                        })}
                  </div>
                ) : liveTabValue === 1 ? (
                  <>
                    <div
                      className={courseVideo.courseCertification}
                      style={{ marginTop: 20 }}
                    >
                      <div className={courseVideo.authorName}>
                        Certification
                      </div>
                      <div className={courseVideo.descriptionText}>
                        Get Course certification by completing entire course
                      </div>
                      {isCourseCompleted?.length === 0 ? (
                        <div
                          className={courseVideo.activeCertificateStyle}
                          onClick={async () => {
                            try {
                              const { data, status } =
                                await api.createCertifiacte({
                                  studentId: `${user?._id}`,
                                  courseId: `${id}`,
                                  adminSignature: [
                                    "https://kingster-dev-public.s3.ap-south-1.amazonaws.com/undefined/7817353944849605475.jpg",
                                  ],
                                });

                              if (status === 200) {
                                navigate(
                                  `/courses/Courses/CourseDetails/CoursesVideos/CourseCompletion/${id}/${user?._id}`
                                );
                              } else {
                                alert(
                                  "Unable to complete the action. Please try again."
                                );
                              }
                            } catch (error) {
                              Toastify.error(error?.response?.data?.message);
                            }
                          }}
                        >
                          <DocumentWhiteIcon />
                          <span>Kingster Certificate</span>
                        </div>
                      ) : (
                        <div className={courseVideo.certificateStyle}>
                          <img src="/event_note.png" />
                          <span>Kingster Certificate</span>
                        </div>
                      )}
                    </div>
                    <div
                      className={courseVideo.courseCertification}
                      style={{ marginTop: 20 }}
                    >
                      <div className={courseVideo.authorName}>Description</div>
                      <div className={courseVideo.descriptionText}>
                        <p>
                          It gives you a huge self-satisfaction when you look at
                          your work and say, "I made this!". I love that feeling
                          after I'm done working on something. When I lean back
                          in my chair, look at the final result with a smile,
                          and have this little "spark joy" moment. It's
                          especially satisfying when I know I just made $5,000.
                        </p>
                        <p>
                          I do! And that's why I got into this field. Not for
                          the love of Web Design, which I do now. But for the
                          LIFESTYLE! There are many ways one can achieve this
                          lifestyle. This is my way. This is how I achieved a
                          lifestyle I've been fantasizing about for five years.
                          And I'm going to teach you the same. Often people
                          think Web Design is complicated. That it needs some
                          creative talent or knack for computers. Sure, a lot of
                          people make it very complicated. People make the
                          simplest things complicated. Like most subjects taught
                          in the universities. But I don't like complicated. I
                          like easy. I like life hacks. I like to take the
                          shortest and simplest route to my destination. I
                          haven't gone to an art school or have a computer
                          science degree. I'm an outsider to this field who
                          hacked himself into it, somehow ending up being a
                          sought-after professional. That's how I'm going to
                          teach you Web Design. So you're not demotivated on
                          your way with needless complexity. So you enjoy the
                          process because it's simple and fun. So you can become
                          a Freelance Web Designer in no time.
                        </p>
                        <p>
                          For example, this is a Design course but I don't teach
                          you Photoshop. Because Photoshop is needlessly
                          complicated for Web Design. But people still teach it
                          to web designers. I don't. I teach Figma – a simple
                          tool that is taking over the design world. You will be
                          designing a complete website within a week while
                          others are still learning how to create basic layouts
                          in Photoshop.
                        </p>
                        <p>
                          Second, this is a Development course. But I don't
                          teach you how to code. Because for Web Design coding
                          is needlessly complicated and takes too long to learn.
                          Instead, I teach Webflow – a tool that is taking over
                          the web design world. You will be building complex
                          websites within two weeks while others are still
                          learning the basics of HTML & CSS. Third, this is a
                          Freelancing course. But I don't just teach you how to
                          write great proposals. I give you a winning proposal
                          template. When you're done with the course, you will
                          have a stunning portfolio website with portfolio
                          pieces already in it. Buy this course now and take it
                          whenever the time is right for you.
                        </p>
                      </div>
                    </div>
                  </>
                ) : liveTabValue === 2 ? (
                  <>
                    <Quiz
                      isCompleted={isCourseCompleted}
                      courseType={courseDetailsData?.course?.courseType}
                      quizData={quizData}
                      isLoading={isLoading}
                    />
                  </>
                ) : liveTabValue === 3 ? (
                  <>
                    <Assignment
                      isCompleted={isCourseCompleted}
                      courseType={courseDetailsData?.course?.courseType}
                      activeAssignmentData={activeAssignmentData}
                      isLoading={isLoading}
                    />
                  </>
                ) : liveTabValue === 4 ? (
                  <>
                    <LiveSession
                      liveSessionData={liveSessionData}
                      isLoading={isLoading}
                    />
                  </>
                ) : liveTabValue === 5 ? (
                  <CommentSection
                    data={comments}
                    id={id}
                    setData={setComments}
                    fetchData={fetchComments}
                  />
                ) : null}
              </Box>
            </div>
          </div>
          <div className={courseVideo.videoSessionBox}>
            <div className={courseVideo.courseContent}>
              {courseDetailsData?.course?.courseType === "LIVESTREAM" ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 20px",
                      borderBottom: "1px solid #E9EAF0",
                    }}
                  >
                    <div
                      onClick={() => setLiveTabValue(0)}
                      style={{
                        cursor: "pointer",
                        padding: "10px 15px",
                        fontWeight: liveTabValue === 0 ? "600" : "400",
                        color: liveTabValue === 0 ? "#1D83F8" : "#6E7485",
                        borderBottom:
                          liveTabValue === 0 ? "2px solid #1D83F8" : "none",
                      }}
                    >
                      Live Sessions
                    </div>
                    <div
                      onClick={() => setLiveTabValue(1)}
                      style={{
                        cursor: "pointer",
                        padding: "10px 15px",
                        fontWeight: liveTabValue === 1 ? "600" : "400",
                        color: liveTabValue === 1 ? "#1D83F8" : "#6E7485",
                        borderBottom:
                          liveTabValue === 1 ? "2px solid #1D83F8" : "none",
                      }}
                    >
                      Recorded Videos
                    </div>
                  </div>

                  {liveTabValue === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        background: "rgba(248, 93, 93, 0.05)",
                        padding: "20px",
                      }}
                    >
                      <div style={{ width: "80%" }}>
                        <div
                          style={{
                            color: "rgba(249, 51, 51, 1)",
                            marginBottom: "10px",
                          }}
                        >
                          Live session
                        </div>

                        {upcomingSession ? (
                          <div style={{ fontWeight: "400", fontSize: "12px" }}>
                            {formatLivesessionDateTime(
                              upcomingSession.liveSessionDate,
                              upcomingSession.liveSessionStartTime,
                              upcomingSession.liveSessionEndTime
                            )}
                          </div>
                        ) : (
                          <span>No live sessions available</span>
                        )}
                      </div>

                      {upcomingSession && (
                        <button
                          onClick={() => {
                            if (upcomingSession?.meetingURL) {
                              navigate(
                                `/courses/join/${upcomingSession.meetingId}?meetingPassword=${upcomingSession.meetingPassword}&callbackURL=${location.pathname}`
                              );
                            }
                          }}
                          style={{
                            color: "#fff",
                            background: "rgba(29, 131, 248, 1)",
                            borderRadius: "25px",
                            padding: "15px 19px",
                          }}
                        >
                          Join
                        </button>
                      )}
                    </div>
                  ) : (
                    <div style={{ padding: "20px" }}>Recorded Videos</div>
                  )}
                </>
              ) : (
                <div style={{ padding: "20px" }}>Course content</div>
              )}
            </div>

            {/* For non-LIVESTREAM courses, show modules. For LIVESTREAM courses, show modules in Live Sessions tab and recordedModules in Recorded Videos tab */}
            {courseDetailsData?.course?.courseType !== "LIVESTREAM"
              ? // Regular courses - show modules
                courseDetailsData?.course?.modules?.map((section, index) => {
                  const watchedLectures = section?.lectures?.filter(
                    (lecture) => watchedCounts[lecture._id]
                  ).length;
                  const totalLectures = section?.lectures?.length;
                  return (
                    <div key={index} className={courseVideo.courseSection}>
                      <div
                        className={
                          expandedSection === index && moduleId === section?._id
                            ? `${courseVideo.selectedLessonStyle}`
                            : `${courseVideo.courseSectionHeader}`
                        }
                        onClick={() => toggleSection(index, section?._id)}
                      >
                        <div>
                          <div>
                            {" "}
                            {index < 9 && 0}
                            {index + 1} - {section.title}
                          </div>
                          <span className={courseVideo.lessonDuration}>
                            {watchedLectures}/{totalLectures}
                          </span>
                          <span className={courseVideo.lessonDuration}>
                            ({formatDuration(section.totalModuleDuration)})
                          </span>
                        </div>
                        <div>
                          {expandedSection === index &&
                          moduleId === section?._id ? (
                            <BlackDropUpIcon />
                          ) : (
                            <Dropdown />
                          )}
                        </div>
                      </div>
                      {expandedSection === index &&
                        section?.lectures?.length > 0 && (
                          <div className={courseVideo.lessonList}>
                            {section?.lectures?.map((lesson, lessonIndex) => (
                              <div
                                key={lessonIndex}
                                className={
                                  selectedLesson === lessonIndex
                                    ? courseVideo.selectedLesson
                                    : courseVideo.lessonItem
                                }
                                onClick={async () =>
                                  await selectLesson(
                                    lessonIndex,
                                    lesson.video, // Pass the video URL
                                    lesson._id,
                                    lesson.totalLectureDuration
                                  )
                                }
                              >
                                <div className={courseVideo.selectedSubVideo}>
                                  <div>
                                    {selectedLesson === lessonIndex ||
                                    watchedCounts[lesson._id] ? (
                                      <FaCheckCircle
                                        className={courseVideo.playIcon}
                                      />
                                    ) : (
                                      <FaRegCircle
                                        className={courseVideo.circleIcon}
                                      />
                                    )}
                                  </div>
                                  <div>
                                    <div className={courseVideo.headinStyle}>
                                      <img src="/videoIcon.png" />
                                      {lessonIndex < 9 && 0}
                                      {lessonIndex + 1} - {lesson.title}
                                    </div>
                                    <span
                                      className={courseVideo.lessonDuration}
                                    >
                                      (
                                      {formatDuration(
                                        lesson?.totalLectureDuration
                                      )}
                                      )
                                    </span>
                                  </div>
                                </div>
                                {selectedLesson === lessonIndex &&
                                  lesson?.attachFiles?.url?.length > 0 && (
                                    <div
                                      className={courseVideo.lessonOptions}
                                      onClick={() => {
                                        window.open(
                                          lesson?.attachFiles?.url?.[0],
                                          "_blank"
                                        );
                                      }}
                                    >
                                      <img src="/event_note.png" />
                                      <span>Resources</span>
                                    </div>
                                  )}
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  );
                })
              : // LIVESTREAM courses - show modules or recordedModules based on tab
              liveTabValue === 0
              ? // Live Sessions tab - show modules
                courseDetailsData?.course?.modules?.map((section, index) => {
                  const watchedLectures = section?.lectures?.filter(
                    (lecture) => watchedCounts[lecture._id]
                  ).length;
                  const totalLectures = section?.lectures?.length;
                  return (
                    <div key={index} className={courseVideo.courseSection}>
                      <div
                        className={
                          expandedSection === index && moduleId === section?._id
                            ? `${courseVideo.selectedLessonStyle}`
                            : `${courseVideo.courseSectionHeader}`
                        }
                        onClick={() => toggleSection(index, section?._id)}
                      >
                        <div>
                          <div>
                            {" "}
                            {index < 9 && 0}
                            {index + 1} - {section.title}
                          </div>
                          <span className={courseVideo.lessonDuration}>
                            {watchedLectures}/{totalLectures}
                          </span>
                          <span className={courseVideo.lessonDuration}>
                            ({formatDuration(section.totalModuleDuration)})
                          </span>
                        </div>
                        <div>
                          {expandedSection === index &&
                          moduleId === section?._id ? (
                            <BlackDropUpIcon />
                          ) : (
                            <Dropdown />
                          )}
                        </div>
                      </div>
                      {expandedSection === index &&
                        section?.lectures?.length > 0 && (
                          <div className={courseVideo.lessonList}>
                            {section?.lectures?.map((lesson, lessonIndex) => (
                              <div
                                key={lessonIndex}
                                className={
                                  selectedLesson === lessonIndex
                                    ? courseVideo.selectedLesson
                                    : courseVideo.lessonItem
                                }
                                onClick={async () =>
                                  await selectLesson(
                                    lessonIndex,
                                    lesson.video, // Pass the video URL
                                    lesson._id,
                                    lesson.totalLectureDuration
                                  )
                                }
                              >
                                <div className={courseVideo.selectedSubVideo}>
                                  <div>
                                    {selectedLesson === lessonIndex ||
                                    watchedCounts[lesson._id] ? (
                                      <FaCheckCircle
                                        className={courseVideo.playIcon}
                                      />
                                    ) : (
                                      <FaRegCircle
                                        className={courseVideo.circleIcon}
                                      />
                                    )}
                                  </div>
                                  <div>
                                    <div className={courseVideo.headinStyle}>
                                      <img src="/videoIcon.png" />
                                      {lessonIndex < 9 && 0}
                                      {lessonIndex + 1} - {lesson.title}
                                    </div>
                                    <span
                                      className={courseVideo.lessonDuration}
                                    >
                                      (
                                      {formatDuration(
                                        lesson?.totalLectureDuration
                                      )}
                                      )
                                    </span>
                                  </div>
                                </div>
                                {selectedLesson === lessonIndex &&
                                  lesson?.attachFiles?.url?.length > 0 && (
                                    <div
                                      className={courseVideo.lessonOptions}
                                      onClick={() => {
                                        window.open(
                                          lesson?.attachFiles?.url?.[0],
                                          "_blank"
                                        );
                                      }}
                                    >
                                      <img src="/event_note.png" />
                                      <span>Resources</span>
                                    </div>
                                  )}
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  );
                })
              : // Recorded Videos tab - show recordedModules
                recordedModules?.map((section, index) => {
                  const watchedLectures = section?.lectures?.filter(
                    (lecture) => watchedCounts[lecture._id]
                  ).length;
                  const totalLectures = section?.lectures?.length;
                  return (
                    <div key={index} className={courseVideo.courseSection}>
                      <div
                        className={
                          expandedSection === index && moduleId === section?._id
                            ? `${courseVideo.selectedLessonStyle}`
                            : `${courseVideo.courseSectionHeader}`
                        }
                        onClick={() => toggleSection(index, section?._id)}
                      >
                        <div>
                          <div>
                            {" "}
                            {index < 9 && 0}
                            {index + 1} - {section.title}
                          </div>
                          <span className={courseVideo.lessonDuration}>
                            {watchedLectures}/{totalLectures}
                          </span>
                          <span className={courseVideo.lessonDuration}>
                            ({formatDuration(section.totalModuleDuration)})
                          </span>
                        </div>
                        <div>
                          {expandedSection === index &&
                          moduleId === section?._id ? (
                            <BlackDropUpIcon />
                          ) : (
                            <Dropdown />
                          )}
                        </div>
                      </div>
                      {expandedSection === index &&
                        section?.lectures?.length > 0 && (
                          <div className={courseVideo.lessonList}>
                            {section?.lectures?.map((lesson, lessonIndex) => (
                              <div
                                key={lessonIndex}
                                className={
                                  selectedLesson === lessonIndex
                                    ? courseVideo.selectedLesson
                                    : courseVideo.lessonItem
                                }
                                onClick={async () =>
                                  await selectLesson(
                                    lessonIndex,
                                    lesson.video, // Pass the video URL
                                    lesson._id,
                                    lesson.totalLectureDuration
                                  )
                                }
                              >
                                <div className={courseVideo.selectedSubVideo}>
                                  <div>
                                    {selectedLesson === lessonIndex ||
                                    watchedCounts[lesson._id] ? (
                                      <FaCheckCircle
                                        className={courseVideo.playIcon}
                                      />
                                    ) : (
                                      <FaRegCircle
                                        className={courseVideo.circleIcon}
                                      />
                                    )}
                                  </div>
                                  <div>
                                    <div className={courseVideo.headinStyle}>
                                      <img src="/videoIcon.png" />
                                      {lessonIndex < 9 && 0}
                                      {lessonIndex + 1} - {lesson.title}
                                    </div>
                                    <span
                                      className={courseVideo.lessonDuration}
                                    >
                                      (
                                      {formatDuration(
                                        lesson?.totalLectureDuration
                                      )}
                                      )
                                    </span>
                                  </div>
                                </div>
                                {selectedLesson === lessonIndex &&
                                  lesson?.attachFiles?.url?.length > 0 && (
                                    <div
                                      className={courseVideo.lessonOptions}
                                      onClick={() => {
                                        window.open(
                                          lesson?.attachFiles?.url?.[0],
                                          "_blank"
                                        );
                                      }}
                                    >
                                      <img src="/event_note.png" />
                                      <span>Resources</span>
                                    </div>
                                  )}
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  );
                })}
          </div>
        </div>
        <div className={courseVideo.footerStyle}>
          <FooterComponent />
        </div>
      </div>

      <ReviwModal
        open={reviewModal}
        closeModal={closeReviewModal}
        data={data}
      />
    </div>
  );
};

export default CoursesVideos;
